import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { TrendingUp } from 'lucide-react';

interface CurrentCashMiniCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export function CurrentCashMiniCardThumbnail({ isHovered = false, alwaysVisible = false }: CurrentCashMiniCardThumbnailProps) {
  // When always visible, show at 40% scale. When hover-only, show at 100% scale (or 2.5x on hover)
  const baseScale = alwaysVisible ? 'scale-[0.4]' : 'scale-100';
  const scale = isHovered ? 'scale-100' : baseScale;
  const zIndex = isHovered ? 'z-50' : 'z-0';
  
  return (
    <div className={`transition-all duration-300 ${scale} ${zIndex} origin-left`}>
      <Card className="w-[300px] border shadow-sm bg-background">
        <CardHeader className="pb-2 px-3 pt-3">
          <CardTitle className="text-[10px] font-medium text-muted-foreground">
            Current Cash
          </CardTitle>
        </CardHeader>
        <CardContent className="px-3 pb-3">
          <div className="text-lg font-bold">£287,450</div>
          <div className="flex items-center gap-1 text-[9px] text-muted-foreground mt-0.5">
            <TrendingUp className="h-2.5 w-2.5 text-green-500" />
            <span>13.7 months coverage</span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
